/** Preferencia compartida de tamaño de página (POS, Catálogo e Inventario). */
export const CATALOG_ADMIN_PAGE_SIZE_STORAGE_KEY = 'catalog_admin_page_size';

export type CatalogListPageSize = 10 | 25 | 50;

/** Lista administrativa full-width: default 25 ítems (ERP-grade); opciones disponibles [10, 25, 50]. */
export const PAGE_SIZE = 25;

/** Paginación del historial de catálogo (alineado con inventario). */
export const CATALOG_HISTORY_PAGE_SIZE = 20;
